const EDIT_NOTE = '/keeps/edit_note';
const SAVE_NOTE = '/keeps/add_note';
const TOGGLE_FAVOURITE = '/keeps/toggle_favourite';
const DELETE_NOTE = '/keeps/delete_note';
const FETCH_KEEPS = '/keeps';

export const API = {

    edit_note: ({ keep_id, entity_id, entity_type, content }) => {
        console.log(keep_id, entity_type, content)

        return fetch(EDIT_NOTE, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ keep_id, entity_id, entity_type, content })
        }).then(response => response.json());
    },

    save_note: ({ entity_id, entity_type, content }) => {
        return fetch(SAVE_NOTE, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ entity_id, entity_type, content })
        }).then(response => response.json());
    },

    delete_note: ({ keep_id, entity_id, entity_type }) => {
        return fetch(DELETE_NOTE, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ keep_id, entity_id, entity_type })
        }).then(response => response.json());
    },

    fetch_keeps: ({ entity_id, entity_type }) => {
        return fetch(FETCH_KEEPS, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ entity_id, entity_type })
        }).then(response => response.json());
    },


    fetch_favourites: ({ keep_type }) => {
        return fetch(FETCH_KEEPS, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ keep_type })
        }).then(response => response.json());
    },


    toggle_favourites: ({ entity_id, entity_type }) => {
        return fetch(TOGGLE_FAVOURITE, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ entity_id, entity_type })
        }).then(response => response.json());
    },

};